// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1vg8V","item":"PaymentsMobile_item__2jNaQ","label":"PaymentsMobile_label__1ipWq","amount":"PaymentsMobile_amount__ruTjY"};